var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgProduct({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4142 16L25.7071 7.70712C25.8944 7.51954 25.9996 7.26526 25.9995 7.00015C25.9994 6.73505 25.8941 6.48083 25.7066 6.29338C25.5192 6.10592 25.265 6.00057 24.9999 6.00049C24.7348 6.00041 24.4805 6.10559 24.2929 6.29293L16 14.5858L7.70709 6.29293C7.51952 6.10559 7.26523 6.00041 7.00013 6.00049C6.73502 6.00057 6.4808 6.10592 6.29335 6.29338C6.10589 6.48083 6.00054 6.73505 6.00046 7.00015C6.00038 7.26526 6.10557 7.51954 6.2929 7.70712L14.5858 16L6.2929 24.2929C6.19995 24.3858 6.1262 24.496 6.07587 24.6174C6.02554 24.7387 5.99961 24.8688 5.99957 25.0002C5.99953 25.1315 6.02538 25.2616 6.07563 25.383C6.12589 25.5044 6.19957 25.6147 6.29246 25.7076C6.38535 25.8005 6.49564 25.8741 6.61702 25.9244C6.7384 25.9746 6.86849 26.0005 6.99987 26.0004C7.13124 26.0004 7.26131 25.9745 7.38266 25.9241C7.50401 25.8738 7.61425 25.8001 7.70709 25.7071L16 17.4142L24.2929 25.7071C24.4805 25.8945 24.7348 25.9996 24.9999 25.9996C25.265 25.9995 25.5192 25.8941 25.7066 25.7067C25.8941 25.5192 25.9994 25.265 25.9995 24.9999C25.9996 24.7348 25.8944 24.4805 25.7071 24.2929L17.4142 16Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.ad44f5d2.svg";
export { ForwardRef as ReactComponent };